import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import UpdateJobDescriptionForm from './UpdateJobDescriptionForm';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';

const UpdateJobDescriptionModal = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { closeUpdateJobDescriptionModal } = useBiopharmaGroupActions();

  return (
    <StandardModal
      isOpen={biopharmaGroupState?.updateJobDescriptionModalIsOpen}
      contentLabel={'Update Job Description'}
      onRequestClose={() => {
        closeUpdateJobDescriptionModal();
      }}
    >
      <PageTitle text={'Update Job Description'} />
      <UpdateJobDescriptionForm />
    </StandardModal>
  );
};

export default UpdateJobDescriptionModal;
